function handleBuyBar() {

  const _s = {
    buybar: document.querySelector('.gdc-product-buy-bar'),
    menu: document.querySelector('.gdc-product-buy-bar__variants'),
    themeSwatches: document.querySelectorAll('.swatch__input'),
    gdcCartButton: document.querySelector('#gdc-product-buy-bar__add-to-cart'),
    gdcCartButtonMobile: document.querySelector('#gdc-product-buy-bar__add-to-cart--mobile'),
    themeCartButton: document.querySelector('.gdc-product__submit__add'),
    gdcSwatches: document.querySelectorAll('.gdc-product-buy-bar__swatch-input'),
    productSelectedInput: document.querySelector('[data-product-select]'),
    buyBarSwatchList: document.querySelectorAll('.gdc-product-buy-bar__variant'),
    productForm: document.querySelector('.product__form__wrapper'),
    productFormCloseButtons: document.querySelectorAll('.gdc-mobile-sticky-product-form__close-btn')
  }

  const _m = {

    init() {
      _m.handleShowOnScroll()
      _m.handlePreselectedThemeSwatch()
      _m.addEventListeners()
    },

    handleShowOnScroll() {
      window.scrollY > window.innerHeight ? _m.showBuyBar() : _m.hideBuyBar()

      // Handles sticky product variants component
      if (screen.width < 700) {
        if (window.scrollY > 1500) {
          _m.stickMobileProductForm()
        } else {
          _m.unstickMobileProductForm()
        }
      }
    },

    showBuyBar() {
      _s.buybar.style.top = '0'
    },

    hideBuyBar() {
      _s.buybar.style.top = '-1000px'
    },

    stickMobileProductForm() {
      _s.productForm.classList.add('gdc-mobile-sticky-product-form')
      _s.gdcCartButtonMobile.style.display = 'flex'
    },

    unstickMobileProductForm() {
      _s.productForm.classList.remove('gdc-mobile-sticky-product-form')
      _s.gdcCartButtonMobile.style.display = 'none'
    },

    handlePreselectedThemeSwatch() {
      const loadedSwatchTitle = _s.productSelectedInput.dataset.loadedVariantTitle
      setTimeout(() => {
        _s.themeSwatches.forEach(swatch => {
          let swatchTitle = swatch.value
          if (swatchTitle === loadedSwatchTitle) {
            swatch.click()
          }
        })
      }, 500);
    },

    addEventListeners() {
      window.addEventListener('scroll', _m.handleShowOnScroll)
      _s.gdcCartButton.addEventListener('click', _m.handleCustomCartButton)
      _s.gdcCartButtonMobile.addEventListener('click', _m.showMobileProductForm)
      _s.productFormCloseButtons.forEach(btn => btn.addEventListener('click', _m.hideMobileProductForm))

      if (_s.themeSwatches && _s.gdcSwatches) {
        _s.themeSwatches.forEach(s => s.addEventListener('click', _m.handleThemeSwatches))
        _s.gdcSwatches.forEach(s => s.addEventListener('click', _m.handleGdcSwatches))
      }

    },

    closeMenu() {
      _s.menu.classList.remove('active-menu')
    },

    handleCustomCartButton() {
      _s.themeCartButton.click()
    },

    showMobileProductForm() {
      _s.productForm.classList.add('show')
    },

    hideMobileProductForm() {
      _s.productForm.classList.remove('show')
    },

    buyBarSwatchId(swatch) {
      return swatch.dataset.gdcVariantId
    },

    buyBarSwatchTitle(swatch) {
      return swatch.dataset.gdcVariantTitle
    },

    changeThemeSwatchSelection(swatch) {
      _s.themeSwatches.forEach(themeSwatch => {
        if (_m.buyBarSwatchTitle(swatch) === themeSwatch.value) {
          themeSwatch.click()
        }
      })
    },

    makeActiveSwatch(swatch) {
      swatch.style.order = 1
    },

    makeInactiveSwatch(swatch) {
      swatch.style.order = 2
    },

    handleThemeSwatches(e) {
      const clickedThemeSwatchTitle = e.target.value

      _s.buyBarSwatchList.forEach(swatch => {
        if (clickedThemeSwatchTitle === _m.buyBarSwatchTitle(swatch)) {
          _m.makeActiveSwatch(swatch)
        } else {
          _m.makeInactiveSwatch(swatch)
        }
      })
    },
    
    handleGdcSwatches(e) {
      const clickedSwatch = e.target.parentElement
      _m.changeThemeSwatchSelection(clickedSwatch)
      _m.closeMenu()
    }
  }

  _m.init()

}

function handleMenu(event) {
  const menu = event.target.closest('.gdc-product-buy-bar__variants')

  const _m = {

    init() {
      window.addEventListener('scroll', _m.closeMenu);
    },

    closeMenu() {
      menu.classList.remove('active-menu')
    },

    toggleMenu() {
      menu.classList.toggle('active-menu')
    }

  }

  _m.init()
  _m.toggleMenu()

}

window.addEventListener('DOMContentLoaded', handleBuyBar);